import { requireAuth } from "../../../../client/utils/auth";

export default async function init(): Promise<void> {
  await requireAuth();
}
